export default __webpack_public_path__ + "static/media/add_circle_white.5d07e90e.svg";